import React from 'react';

const IconPen = props => (<svg viewBox="0 0 12 12" width="12px" height="12px" {...props}>
  <path d="M8.249 0L0.007 8.244L0 12h3.757L12 3.752L8.249 0z M10.264 3.752L8.802 5.214L6.788 3.199l1.461-1.461L10.264 3.752z M3.249 10.771h-2.02l0.004-2.018l4.686-4.687l2.015 2.016L3.249 10.771z" />
</svg>);

export default IconPen;
